import React from "react";
import {FormattedMessage} from "react-intl";
import {CardsSuit, Prediction, PlayerOddType, CardTypeMap, BetsType} from "@constants/Enums";

import RoundInfoItem from "./RoundInfoItem";
import CardList from "./CardList";
import {floatNumberWithSpaces} from "@services/numberFormatServices";

export function RoundHistory({round, getHistoryItemValue}) {

    return (
        <div className="history-round scrollable">
            <div className="history-round-info">
                <RoundInfoItem time={round.startTime}
                               timeTitle="game_start"
                               balance={round.balanceBefore}
                               balanceTitle="balance_before_the_round" />
                <RoundInfoItem time={round.endTime}
                               timeTitle="game_end"
                               balance={round.balanceAfter}
                               balanceTitle="balance_after_the_round" />
            </div>
            <div className="round-cards">
                <CardList player={<FormattedMessage id="dragon" />}
                          cards={{type: CardTypeMap[round.roundParticipants[0].cardNumber], suit: CardsSuit[round.roundParticipants[0].cardSuit]}}
                          winner={round.BetEvent === PlayerOddType.Dragon || round.BetEvent === PlayerOddType.Tie || round.BetEvent === PlayerOddType.SuitedTie}/>

                <CardList player={<FormattedMessage id="tiger" />}
                          cards={{type: CardTypeMap[round.roundParticipants[1].cardNumber], suit: CardsSuit[round.roundParticipants[1].cardSuit]}}
                          winner={round.BetEvent === PlayerOddType.Tiger || round.BetEvent === PlayerOddType.Tie || round.BetEvent === PlayerOddType.SuitedTie}/>
            </div>
            <div className="round-bets">
                <div className="tbl">
                    <div className="row">
                        <div className="cell"><FormattedMessage id="bet_type" /></div>
                        <div className="cell"><FormattedMessage id="bet" /></div>
                        <div className="cell"><FormattedMessage id="odd" /></div>
                        <div className="cell"><FormattedMessage id="win_lose" /></div>
                    </div>
                    {
                        round.bets.map((item, index) => (
                            <div className="row" key={index}>
                                <div className="cell"><FormattedMessage id={Prediction[item.betEvent]} /></div>
                                <div className="cell">{floatNumberWithSpaces(item.stake)}</div>
                                <div className="cell">{floatNumberWithSpaces(item.odd)}</div>
                                
                                <div className="cell">{floatNumberWithSpaces(item.status === BetsType.win ? item.win : item.status === BetsType.refund ? 0 : -item.stake || 0, 0)}</div>
                            </div>
                        ))
                    }
                    <div className="row">
                        <div className="cell"><FormattedMessage id="total" />:</div>
                        <div className="cell">{floatNumberWithSpaces(round.bets.reduce((a, b) => b.stake + a, 0))}</div>
                        <div className="cell"></div>
                        <div className="cell">{floatNumberWithSpaces(round.bets.reduce((a, b) => (b.status === BetsType.win ? b.win : b.status === BetsType.refund ? 0 : b.status === BetsType.lose ? -b.stake : 0) + a, 0), 0)}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default RoundHistory;